import { styled } from 'styletron-react';

const PriceTag = styled('p', {
  color: `#007c94!important`,
  marginBottom: '-10px',
  fontSize: '64px',
  lineHeight: '64px',
  '@media (max-width: 767px)': {
    fontSize: '38px',
    lineHeight: '38px'
  }
});

const PriceTagSmall = styled('span', {
  fontSize: '24px',
  lineHeight: '48px',
  '@media (max-width: 767px)': {
    fontSize: '20px',
    lineHeight: '48px'
  }
});

export { PriceTag, PriceTagSmall };
